// Backend marks an empty Second/Third holder slot with the literal sentinel "N"
// (confirmed with the BE team) instead of omitting the object. Per BE, the agreed
// interim contract is: when the holder name is exactly "N", do not display it.
// Everything else is treated as a real, displayable name.
// ponytail: exact-"N" match per BE agreement; the permanent fix is the backend
// returning null for empty slots. If a real holder were literally named "N" it
// would be hidden, but BE confirmed "N" is only ever the empty-slot marker.
export const isValidHolderName = (name: string | undefined | null): boolean => {
  if (!name) return false;
  const cleaned = name.trim();
  if (cleaned.length === 0) return false;
  return cleaned.toUpperCase() !== "N";
};
